const stylesModal = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1500,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
    position: 'absolute',
    fontFamily: 'Raleway, sans-serif',
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalHeaderH2: {
    margin: 0,
    color: "#4e5864ff",
    
    fontFamily: 'Raleway, sans-serif',
  },
  modalHeaderH4: {
    margin: 0,
    color: "#616d71",
    fontFamily: 'Raleway, sans-serif',
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "1.5rem",
    cursor: "pointer",
    color: "#333",
  },
  modalDivider: {
    border: "1px solid #ccc",
    margin: "20px 0",
  },
  modalContent: {
    marginTop: "10px",
  },
  modalButtons: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "1.7rem",
  },
};

export default stylesModal;
